import * as PowerBI from 'powerbi-client';

const tableNames = {
  'design': 'designtable',
  'intervention': 'interventiontable',
  'coilscan': 'coilscantable'
}

async function getContainerNames(visuals: any, tableName: string): Promise<string[]> {
  const containerList = visuals.filter(x => x.type === "multiRowCard" && x.title === tableName)[0];
  if (containerList == null) {
    return [];
  }
  const table = (await containerList.exportData(PowerBI.models.ExportDataType.Summarized)).data;

  const rows = table.split('\n').map(x => x.trim()).filter(x => x.length > 0);
  if (rows.length < 2) {
    return [];  
  }

  const headers = rows[0].split(',');
  const containerNameIndex = headers.indexOf('Acquisitions');
  if (containerNameIndex < 0) {
    return [];
  }

  return rows.slice(1).map(x => x.split(',')[containerNameIndex]);
}

export async function getVisuals(report: PowerBI.Embed) {
  const pages = await (report as any).getPages();
  const activePage = pages.filter(x => x.isActive)[0];
  return activePage.getVisuals();
}

export async function getSelectedContainers(report: PowerBI.Embed, type: string = null) : Promise<string[]> {
  const visuals = await getVisuals(report);

  const tablesToCheck = Object.keys(tableNames).filter(x => !type || type === x).map(x => tableNames[x]);

  const containers = await Promise.all(tablesToCheck.map(x => getContainerNames(visuals, x)));

  return [].concat(...containers);
}
